<template>
    <div>
        <el-form :inline="true"  class="demo-form-inline">
            <el-form-item>
                <el-input v-model="query" placeholder="输入名称或结算账号" />
            </el-form-item>
            <el-form-item style="margin-left: 10px">
                <el-button type="primary" icon="el-icon-search" @click="getList()"></el-button>
            </el-form-item>
        </el-form>
        <div style="max-height: 485px; overflow: auto">
            <el-table
                v-loading="listLoading"
                :data="list"
                border
                fit
                highlight-current-row
                @row-dblclick="selectAccountDb"
                @row-click="selectAccount"
            >
                <el-table-column width="35" align="center">
                    <template slot-scope="{ row }">
                        <el-radio v-model="radio" :label="row.id">{{
                            ""
                        }}</el-radio>
                    </template>
                </el-table-column>
                <el-table-column
                    v-for="(col, index) in cols"
                    :key="index"
                    align="center"
                    :label="col.label"
                    :width="col.width"
                >
                    <template slot-scope="{ row }">
                        <span>{{ row[col.prop] }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            query:"",
            list: null,
            radio: 1,
            listLoading: false,
            cols: [
                {
                    prop: "id",
                    label: "编号",
                    width: 60,
                },
                {
                    prop: "name",
                    label: "名称",
                },
                {
                    prop: "account",
                    label: "结算账号",
                },
            ],
            total: 0,
        };
    },
    created() {
        this.getList();
    },
    methods: {
        async getList() {
            this.listLoading = true;
            this.$api.companygetCompanyAccount({query:this.query}).then((res) => {
                this.list = res.data.data;
                this.total = res.data.count;
            });

            this.listLoading = false;
        },
        selectAccount(row) {
            this.radio = row.id;
        },
        selectAccountDb(row) {
            this.radio = row.id;
            this.checkAccount();
        },
        checkAccount() {
            this.list.map((item) => {
                if (item.id === this.radio) {
                    this.$emit("close", item);
                }
            });
        },
    },
};
</script>